<template>
    <div>
        <ul id="slide-out" class="sidenav blue-ugb">
            <li><img src="https://repositorio.ugb.edu.sv/resources/img/ugb/logos_nuevos/UGB_300x100_blanco.png"></li>
            <li><a class="waves-effect white-text" v-if="showMenu('Facturacion')" href="/Facturacion">Facturacion</a></li>
            <li><a class="waves-effect white-text" v-if="showMenu('FacturacionClientes')" href="/FacturacionClientes">Facturacion Clientes</a></li>
            <li><a class="waves-effect white-text" v-if="showMenu('Comprobantes')" href="/Comprobantes">Comprobantes</a></li>
            <li><a class="waves-effect white-text" v-if="showMenu('Reportes')" href="/Reportes">Reportes</a></li>
            <li><a class="waves-effect white-text" v-if="showMenu('EnlacePago')" href="/EnlacePago">Enlaces de Pago</a></li>
            <li class="divider"></li>
            <li><a class="waves-effect white-text" v-if="showMenu('Aranceles')" href="/Aranceles">Aranceles</a></li>
            <li><a class="waves-effect white-text" v-if="showMenu('Tirajes')" href="/Tirajes">Tirajes</a></li>
            <li><a class="waves-effect white-text" v-if="showMenu('FechasLimites')" href="/FechasLimites">Fechas Límites</a></li>
            <li><a class="waves-effect white-text" v-if="showMenu('ArancelesCarrera')" href="/ArancelesCarrera">Aranceles Carrera</a></li>
            <li><a class="waves-effect white-text" v-if="showMenu('Clientes')" href="/ClientesAdmin">Clientes</a></li>
            <li><a class="waves-effect white-text" v-if="showMenu('Estudiantes')" href="/Estudiantes">Estudiantes</a></li>
            <li class="divider"></li>
            <li><a href="#!" class="waves-effect white-text" @click="Logout">Salir</a></li>
        </ul>        
    </div>
</template>

<script>
    export default {
        methods: {
            showMenu(menu)
            {
                return this.$store.state.menus.find(x=>x.mec_menu == menu) != undefined;
            },
            Logout() {
                this.$store.commit('logout');
            }
        }
    }
</script>
